// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__sa8HL","rightAdornment":"Header_rightAdornment__1Yw76"};